module.exports = __webpack_public_path__ + "static/media/influencer-3.bc61e941.png";